export const TODAY_PAGE_SIZES = [10, 20, 30, 40, 50] as const;
export type TodayPageSize = (typeof TODAY_PAGE_SIZES)[number];

export const TODAY_DENSITIES = ["comfortable", "cozy", "compact"] as const;
export type TodayListDensity = (typeof TODAY_DENSITIES)[number];

export const TODAY_DENSITY_LABELS: Record<TodayListDensity, string> = {
  comfortable: "Comfortable",
  cozy: "Cozy",
  compact: "Compact",
};

const PAGE_SIZE_KEY = "ceo-cmd:today-page-size";
const DENSITY_KEY = "ceo-cmd:today-density";

export function isTodayPageSize(value: number): value is TodayPageSize {
  return (TODAY_PAGE_SIZES as readonly number[]).includes(value);
}

export function isTodayListDensity(value: string): value is TodayListDensity {
  return (TODAY_DENSITIES as readonly string[]).includes(value);
}

export function loadTodayPageSize(): TodayPageSize {
  try {
    const raw = Number(localStorage.getItem(PAGE_SIZE_KEY));
    if (isTodayPageSize(raw)) return raw;
  } catch {
    /* ignore */
  }
  return 10;
}

export function saveTodayPageSize(size: TodayPageSize): void {
  try {
    localStorage.setItem(PAGE_SIZE_KEY, String(size));
  } catch {
    /* ignore */
  }
}

export function loadTodayListDensity(): TodayListDensity {
  try {
    const raw = localStorage.getItem(DENSITY_KEY) ?? "";
    if (isTodayListDensity(raw)) return raw;
  } catch {
    /* ignore */
  }
  return "comfortable";
}

export function saveTodayListDensity(density: TodayListDensity): void {
  try {
    localStorage.setItem(DENSITY_KEY, density);
  } catch {
    /* ignore */
  }
}
